import { Component, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoadingController, ModalController, NavController, NavParams } from 'ionic-angular';
import * as moment from 'moment';
import { HttpParams, HttpClient } from '@angular/common/http';
import { Globals } from '../../../../globals';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { AdvancedAnalyticsServices } from '../../advanced-analytics-services';
import { SelectBetweenDatetime } from '../../../components/popups/select-between-datetime/select-between-datetime';

/**
 * Generated class for the StockElementPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-stock-element',
  templateUrl: 'stock-element.html',
})
export class StockElementPage {

  chartData: any;
  chartLabels: any;
  chartCheck: any;
  element: any;
  //datatable
  rows = [];
  temp = [];
  columns = [
    { prop: 'date', name: this.translate.instant('general-fecha') },
    { prop: 'incr_decr', name: this.translate.instant('config-logs-valor') },
    { prop: 'measurement', name: this.translate.instant('general-medida') },
    { prop: 'MODIFIER', name: this.translate.instant('general-elemento') },
    { prop: 'type', name: this.translate.instant('general-tipo') },
    { prop: 'comment', name: this.translate.instant('provider-order-comentario') },
  ];
  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public translate: TranslateService,
    public http: HttpClient,
    public advancedAnalyticsServices: AdvancedAnalyticsServices,
    public modalCtrl: ModalController) {
    this.element = this.navParams.get('element');
    this.getAnalyticsData();
  }


  //funcion que abre el modal para seleccionar fechas
  openSelectDatetimeModal() {
    let profileModal = this.modalCtrl.create(SelectBetweenDatetime, {
      title: this.translate.instant('analytics-titulo-fechas'),
      date_first: this.advancedAnalyticsServices.date1,
      date_last: this.advancedAnalyticsServices.date2,
      cash_bool: false,
    });
    profileModal.onDidDismiss(data => {
      if (data) {
        this.advancedAnalyticsServices.date1 = data.date_first;
        this.advancedAnalyticsServices.date2 = data.date_last;
        //
        this.getAnalyticsData();
      }
    });
    profileModal.present();
  }

  async getAnalyticsData() {

    const params = new HttpParams()
      .set('public_key', this.globals.public_key)
      .set('uid_element', this.element.UID)
      .set('first_date', moment(this.advancedAnalyticsServices.date1).format('YYYY-MM-DD HH:mm:ss'))
      .set('last_date', moment(this.advancedAnalyticsServices.date2).format('YYYY-MM-DD HH:mm:ss'))
      .set('currency_lang', this.globals.currency_lang);


    this.chartCheck = false;
    this.http.post(this.globals.analytics_path + 'analytics/stock_indv_increment_deduct', params, {})
      .subscribe(async response => {
        //chart
        this.chartData = [];
        response['data_stock']['data'].forEach(data => {
          this.chartData.push(parseFloat(data));
        });
        //this.chartData = response['data_stock']['data']; //total's
        this.chartLabels = response['data_stock']['labels'];//Dates
        this.chartCheck = true;//boolean check
      });

    this.http.post(this.globals.analytics_path + 'analytics/stock_indv_increment_deduct_list', params, {})
      .subscribe(async response => {
        //list
        this.rows = response['list'];
        this.temp = response['list'];
      });
  }

  updateFilter(event) {
    const val = event.target.value.toLowerCase();

    // filter our data
    const temp = this.temp.filter(function (d) {
      return d.date.toLowerCase().indexOf(val) !== -1 || !val;
    });

    // update the rows
    this.rows = temp;
    // Whenever the filter changes, always go back to the first page
    this.table.offset = 0;
  }

}



// WEBPACK FOOTER //
// ./src/pages/analytics/reports/stock-element/stock-element.ts